<template>
  <section class="consultant pt-30">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="logo-samas">
            <div>În parteneriat cu</div>
            <img src="../../assets/images/image-secretele-laptelui/logoasociatia.png" style="height: 52px">
          </div>
        </div>

      </div>
    </div>
    <div class="consultant-section">
      <div class="container">
        <div class="row justify-content-between align-items-center">

          <div class="col-lg-3 col-md-12">
            <div class="date-consultant">
              <img src="../../assets/images/image-secretele-laptelui/image-consultant.png">
              <div class="name-consultant-mobil">
                <h2>Gianina Romanescu <br><span>Educator Perinatal SAMAS
și consultant în alăptare</span></h2>
              </div>
              <div class="name-consultant-desktop">
                <h2>Gianina Romanescu <br><span>Educator Perinatal SAMAS
și <br> consultant în alăptare</span></h2>

              </div>
            </div>
          </div>


          <div class="d-none d-md-block col-lg-9 col-md-12 consultant-info">
            <div class="col-12">
              <div>
                <p>
                  Gianina este consultant certificat SAMAS încă din 2013 și, de atunci, participă
                  constant la cursuri de perfecționare, atât ca educator perinatal, cât și ca formator
                  în cadrul asociației.
                </p>
              </div>
            </div>
            <div class="col-12">
              <p>Urmându-și vocația, ajută mamele să inițieze alăptarea și să depășească problemele
                apărute în timpul alăptării prin transfer de cunoștințe și abilități care le cresc
                încrederea, stima de sine și autonomia.</p>
            </div>
          </div>
          <div class="d-block d-md-none col-lg-9 col-md-12 consultant-info">
            <div class="col-12">
              <div class="collapse" id="moreDoctor">
                <p>
                  Gianina este consultant certificat SAMAS încă din 2013 și, de atunci, participă
                  constant la cursuri de perfecționare, atât ca educator perinatal, cât și ca formator
                  în cadrul asociației.
                </p>
                <p>Urmându-și vocația, ajută mamele să inițieze alăptarea și să depășească problemele
                  apărute în timpul alăptării prin transfer de cunoștințe și abilități care le cresc
                  încrederea, stima de sine și autonomia.</p>
              </div>
              <div class="text-center">
                <a class="more-mobil" data-toggle="collapse" href="#moreDoctor" role="button"
                   aria-expanded="false" aria-controls="moreDoctor" @click="actionTricks()">
                  <span v-if="!show_more">Află mai  multe </span>
                  <span v-else>Află mai puține</span>
                </a>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show_more: false,
    }
  },
  methods: {
    actionTricks() {
      if (this.show_more) {

        this.show_more = false
      } else {
        this.show_more = true
      }
    },
  }
}
</script>

<style scoped lang="scss">
.consultant {
  h2 {
    font-size: 20px;
    font-weight: 800;
    color: #009FE3;

    span {
      font-size: 16px;
      font-weight: 500;
      color: #707070;
    }

  }

  .consultant-section {
    background: #C4E4F9;
    padding: 40px 0;
    height: 346px;

    .consultant-info p {
      color: #707070;
    }

    .date-consultant {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        display: flex;
        margin: auto;
      }
    }
  }

  p {
    span {
      color: #029FE3;
    }
  }

  .consultant .name-consultant-desktop h2 {
    font-weight: 600;
  }

  .logo-samas {
    margin: 40px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    div {
      font-size: 12px;
      font-weight: 600;
      color: #17479E;
      text-transform: uppercase;
    }
  }

  .name-consultant-mobil {
    display: none;
  }

  .name-consultant-desktop {
    height: 100%;
    position: relative;

    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #009FE3;
      text-align: center;
    }

    p {
      font-size: 16px;
      color: #707070;
      text-align: center;
    }
  }
}

@media screen and (max-width: 992px) {
  .consultant .consultant-section {
    height: auto;
  }
  .consultant .logo-samas {
    text-align: center;
    margin: 18px 0;
  }
  .consultant-info {
    text-align: left;
  }

  .consultant .consultant-section .date-consultant {
    display: flex;
    align-items: center;
    flex-direction: row;

    img {
      width: 89px !important;
      height: 89px !important;
    }

    .name-consultant-mobil {
      text-align: left;

      h2 {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
  .name-consultant-mobil {
    display: block !important;
    margin-left: 15px;
  }
  .name-consultant-desktop {
    display: none;
  }
}
</style>
